import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-tree-select',
  templateUrl: './common-tree-select.component.html',
  styleUrls: ['./common-tree-select.component.scss']
})
export class CommonTreeSelectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
